<template>
  <div class="recap-option" :class="componentClasses">
    <div class="col flex justify-center items-center full-width">
      <!-- left icon -->
      <section class="recap-option-icon">
        <QIcon
          v-if="(isBoostSalaryStep && isBoosted) || !isBoostSalaryStep"
          :name="hasError ? 'fad fa-triangle-exclamation' : iconLeft || 'fad fa-user'"
          size="28px"
          :color="isBoostSalaryAvailable && isBoosted ? 'secondary' : 'primary'"
        />
      </section>
      <section class="recap-option-body">
        <!-- label -->
        <label>{{ label }}</label>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p class="text-primary text-bold" v-html="formattedData" />
        <p v-if="!!hasError && !!error" class="text-negative text-caption text-italic">
          {{ error }}
        </p>
      </section>
      <!-- right icon -->
      <section class="recap-option-icon">
        <QBtn :label="btnLabel" no-caps dense outline :color="color" class="q-px-sm" @click="$emit('onAction')" />
      </section>
    </div>

    <div v-if="isBoostSalaryAvailable && !isBoosted" class="col flex justify-center items-center full-width recap-option-boost-hint">
      <section class="recap-option-icon">
        <QIcon name="fa fa-bolt" size="sm" color="secondary" />
      </section>
      <section class="recap-option-body">
        <!-- label -->
        <p class="text-body2">
          {{ $t("ETAB.PAGES.DEMANDS.CREATION.@RECAP_BOOST_HINT") }}
        </p>
      </section>
    </div>
  </div>
</template>

<script>
  import { NumericHelpers } from "@core/helpers";
  import { JavascriptHelpers } from "@core/helpers";
  export default {
    props: {
      slug: {
        type: String,
        default: "",
      },
      label: {
        type: String,
        default: "",
      },
      error: {
        type: String,
        default: "",
      },
      hasError: {
        type: Boolean,
        required: true,
      },
      color: {
        type: String,
        default: "",
      },
      addLabel: {
        type: String,
        default: "",
      },
      editLabel: {
        type: String,
        default: "",
      },
      boostLabel: {
        type: String,
        default: "",
      },
      noBoostLabel: {
        type: String,
        default: "",
      },
      iconLeft: {
        type: String,
        required: true,
      },
      data: {
        type: [String, Object, Number],
        default: null,
      },
    },
    emits: ["onAction"],
    computed: {
      btnLabel() {
        if (this.isBoostSalaryStep && !this.isBoostSalaryAvailable) {
          return this.noBoostLabel;
        }
        if (this.isBoostSalaryStep && this.isBoostSalaryAvailable) {
          return !this.isBoosted ? this.boostLabel : this.editLabel;
        }
        return !this.data ? this.addLabel : this.editLabel;
      },
      componentClasses() {
        let classes = "";
        if (this.hasError) {
          classes += "has-error ";
        }
        if (this.isBoostSalaryStep && this.isBoostSalaryAvailable) {
          classes += "recap-option-boost ";
        }
        return classes;
      },
      isBoostSalaryStep() {
        return this.slug === "quote";
      },
      isBoostSalaryAvailable() {
        return this.isBoostSalaryStep && this.data.boost_available;
      },
      isBoosted() {
        return this.isBoostSalaryStep && this.data.boosted_price;
      },
      formattedData() {
        if (this.isBoostSalaryStep) {
          return this.formatBoostStepData(this.data);
        }
        return JavascriptHelpers.trimString(this.data, 500);
      },
    },
    methods: {
      formatBoostStepData(data) {
        if (data.regular_price) {
          if (!data.boosted_price) {
            return NumericHelpers.formatNumberAsCurrency({
              number: data.regular_price,
            });
          }
          return `${NumericHelpers.formatNumberAsCurrency({
            number: data.boosted_price,
          })} <span class="text-strike text-body2 text-grey-5">${NumericHelpers.formatNumberAsCurrency({
            number: data.regular_price,
          })}</span>`;
        }
        // in case we have no price specified
        return "";
      },
    },
  };
</script>

<style lang="scss">
  .test {
    max-height: 300px;
    overflow: hidden;
  }
  .recap-option {
    border-radius: 4px;
    cursor: pointer;
    transition: all 300ms ease;
    box-shadow: $card-shadow;
    margin-bottom: 16px !important;
    margin: 5px auto;
    background: white;
    .q-btn--outline .q-btn__wrapper:before {
      border-width: 1px;
    }
    &.recap-option-boost {
      box-shadow: 0 3px 4px rgba($secondary, 0.15);
      border-radius: 0;
      margin-top: 10;
      margin-left: -30px;
      margin-right: -30px;
      i {
        color: $secondary;
      }
    }
    @media screen and (max-width: $breakpoint-xs-max) {
      &.recap-option-boost {
        margin-left: -8px;
        margin-right: -8px;
        border-left-width: 0;
        border-right-width: 0;
      }
    }
    &:hover {
      background-color: $primary-ultra-light;
      label {
        cursor: pointer; // quasar override
      }

      i {
        color: $primary;
      }
    }
    .recap-option-boost-hint {
      background-color: $secondary-ultra-light;
    }
    .recap-option-icon {
      text-align: center;
      padding: 10px 12px;
      color: $primary-light;

      &:first-of-type {
        color: $primary-lighter;
      }
    }

    .recap-option-body {
      justify-content: left;
      word-break: break-word;
      padding: 15px 8px;
      flex: 1;
      display: flex;
      align-items: left;
      justify-content: center;
      flex-direction: column;
      line-height: 25px;

      ul {
        padding-left: 16px;
        margin: 0;
      }
      > * {
        margin: 0;
      }
    }

    &.has-error {
      background-color: rgba($negative, 0.15);
      color: $negative;
      border-radius: 10px;

      .recap-option-icon {
        color: $negative;
      }
    }
  }
</style>
